// extracted by mini-css-extract-plugin
module.exports = {"icons-with-bullet-lists":"IconsWithBulletLists_icons-with-bullet-lists__sxmHf","icons-with-bullet-lists-item":"IconsWithBulletLists_icons-with-bullet-lists-item__EF41a"};